import {Component, forwardRef, Input, OnChanges, ChangeDetectionStrategy} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {MatFormFieldAppearance} from "@angular/material/form-field";

@Component({
    selector: 'app-time-picker',
    templateUrl: './time-picker.component.html',
    styleUrl: './time-picker.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TimePickerComponent),
            multi: true,
        },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TimePickerComponent implements ControlValueAccessor, OnChanges {
    @Input() label: string = 'Select Time';
    @Input() appearance: MatFormFieldAppearance = 'fill';
    @Input() defaultValue: any;

    times: string[] = [];
    value: string | null = null;
    public disabled: boolean = false;

    constructor() {
        this.generateTimes();
    }

    onChange: (value: string) => void = (value: string): void => {
    };

    onTouched: () => void = (): void => {
    };

    ngOnChanges(): void {
        if (this.defaultValue) {
            this.value = this.findClosestTime(this.times, this.defaultValue);
        }
    }

    timeToMinutes(timeStr: string): number {
        let [hours, minutes] = timeStr.split(":").map(Number);
        return hours * 60 + minutes;
    }

    findClosestTime(times: any, targetTime: string): any {
        let targetMinutes: number = this.timeToMinutes(targetTime);

        return times.reduce((closest: any, current: any): any => {
            return Math.abs(this.timeToMinutes(current) - targetMinutes) <
            Math.abs(this.timeToMinutes(closest) - targetMinutes)
                ? current
                : closest;
        });
    }

    generateTimes(): void {
        const intervals = 15; // 15-minute intervals
        const start = 0; // Start at 00:00
        const end: number = 24 * 60; // End at 24:00
        for (let minutes: number = start; minutes < end; minutes += intervals) {
            const hours: number = Math.floor(minutes / 60);
            const mins: number = minutes % 60;
            const time = `${this.pad(hours)}:${this.pad(mins)}`;
            this.times.push(time);
        }
    }

    pad(num: number): string {
        return num < 10 ? `0${num}` : num.toString();
    }

    writeValue(value: string | null): void {
        this.value = value;
    }

    registerOnChange(fn: (value: string) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    compareCategoryObjects(object1: any, object2: any): any {
        return object1 && object2 && object1 == object2;
    }

    onSelect(value: string): void {
        this.value = value;
        this.onChange(value);
        this.onTouched();
    }
}
